import React, { useState, useRef, useEffect } from "react";

import logo from '../../icons/photos/chillLogo.png'
import PrimaryButton from "../../jsx/components/button/primaryButton";
import './deepLinking.scss'
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";

export default function DeepLinking() {
    const { authorized } = useSelector((state) => state.auth);

    const [webLink, setWebLink] = useState("https://app.chilll.com/login")
    const [appLink, setAppLink] = useState("https://chilll.page.link/inviteFriend")
    const [inviteVal, setInviteVal] = useState(false)


    const [videoVal, setVideoVal] = useState(false)
    const [webLinkVideo, setWebLinkVideo] = useState("https://app.chilll.com/videoCall/?roomId=")
    const [appLinkVideo, setAppLinkVideo] = useState("https://chilll.page.link/inviteFriend")

    const [createPassVal, setCreatePassVal] = useState(false)
    const [webLinkCreatePasword, setWebLinkCreatePassword] = useState("https://app.chilll.com/createPassword/?tokenId=")
    const [appLinkCreatePassword, setAppLinkCreatePassword] = useState("https://chilll.page.link/createPassword/?tokenId=")

    const [shareServiceVal, setShareServiceVal] = useState(false)
    const [webLinkShareService, setWebLinkShareService] = useState("https://app.chilll.com/shareableServiceRequest/?serviceRequestId=")
    const [appLinkShareService, setAppLinkShareService] = useState("https://chilll.page.link/inviteFriend")

    const [companyInvitationVal, setCompanyInvitationVal] = useState(false)
    const [webLinkCompanyInvitation, setWebLinkCompanyInvitation] = useState("https://app.chilll.com/companyInvitation/?companyInvitationToken=")
    const [appLinkCompanyInvitation, setAppLinkCompanyInvitation] = useState("https://chilll.page.link/inviteFriend");

    const [scanVal, setScanVal] = useState(false);

    const [appLinkLoading, setAppLinkLoading] = useState(false);

    // const [baseURI, setBaseURI] = useState('dev-app.chilll');

    const baseURI = process.env.REACT_APP_MY_ENV.replace(/^https:\/\//, "");

    // Detect platform (iOS or Android)
    const userAgent = navigator.userAgent;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);

    useEffect(() => {
        const queryString = window.location.search; //window.location.href

        const urlParams = new URLSearchParams(queryString)

        const request_url = window.location.href



        const page = urlParams.get('page')

        console.log(page, "Deeplink page type")

        if (page == 'video') {
            const request_url = window.location.href

            setWebLink("https://" + request_url.split('/')[2] + "/app/?roomId={room_id}&page=video")
            setVideoVal(true)
            videoLinkView()
        }

        if (page == 'invite') {
            setWebLink(`https://${request_url.split('/')[2]}/login`)
            setInviteVal(true)
            inviteView()
        }

        if (page == 'createPassword') {
            createPasswordView()
        }

        if (page == 'shareableServiceRequest') {
            setWebLinkShareService(`https://${request_url.split('/')[2]}/shareableServiceRequest/?serviceRequestId={serviceRequestId}`)
            setShareServiceVal(true);
            shareServiceView()
        }

        if (page == 'companyInvitation') {
            setWebLinkCompanyInvitation(`https://${request_url.split('/')[2]}/companyInvitation/?companyInvitationToken={companyInvitationToken}`)
            setCompanyInvitationVal(true);
            companyiniteView()
        }

        if (page == 'scan') {
            setWebLink(`https://${request_url.split('/')[2]}/scan`)
            setScanVal(true)
            scanView()
        }

    }, [])

    function videoLinkView() {

        const queryString = window.location.search; //window.location.href

        const urlParams = new URLSearchParams(queryString)
        const request_url = window.location.href
        const page = urlParams.get('page')
        const room_id = urlParams.get('roomId')
        var Name = "Unknown OS";


        if (room_id) {

            if (navigator.userAgent.indexOf("Win") != -1) {
                Name = "Window OS";
                window.location.replace(`https://${request_url.split('/')[2]}/videoCall/?roomId=${room_id}`);
                // window.location.replace(`https://staging-chatapp.chilll.com/${room_id}`);
            }
            setWebLink(`https://${request_url.split('/')[2]}/videoCall/?roomId=${room_id}`)


            // Encode the entire request URL
            const encodedRequestUrl = encodeURIComponent(request_url);

            // Construct app link based on platform
            const appLink = isAndroid
                ? `${baseURI}://deeplink?request_url=${encodedRequestUrl}` // Android app deep link
                : `${baseURI}://deeplink?request_url=${encodedRequestUrl}`; // iOS app deep link

            // Set the app link
            setAppLink(appLink);

            // setWebLinkVideo(`https://${request_url.split('/')[2]}/videoCall/?roomId=${room_id}`)
            // setAppLinkVideo(res["shortLink"])

        }

    }

    function inviteView() {

        const queryString = window.location.search; //window.location.href

        const urlParams = new URLSearchParams(queryString)
        const request_url = window.location.href
        const page = urlParams.get('page')
        const referalCode = urlParams.get('referalCode')
        var Name = "Unknown OS";

        // Deeplink changes for altering firebase dynamic link

        if (referalCode) {
            localStorage.setItem("referalCode", referalCode);

            if (navigator.userAgent.indexOf("Win") != -1) {
                Name = "Window OS";
                window.location.replace(`https://${request_url.split('/')[2]}/signup/?referalCode=${referalCode}`);
                // window.location.replace(`https://staging-chatapp.chilll.com/${room_id}`);
            }

            setWebLink(`https://${request_url.split('/')[2]}/signup/?referalCode=${referalCode}`)
            // setAppLink(res["shortLink"])

            // Encode the entire request URL
            const encodedRequestUrl = encodeURIComponent(request_url);

            // Construct app link based on platform
            const appLink = isAndroid
                ? `${baseURI}://deeplink?request_url=${encodedRequestUrl}` // Android app deep link
                : `${baseURI}://deeplink?request_url=${encodedRequestUrl}`; // iOS app deep link

            // Set the app link
            setAppLink(appLink);
        }


        // Old code ---
        // const request_url = window.location.href
        // if (navigator.userAgent.indexOf("Win") != -1) {
        //     const Name = "Window OS";
        //     window.location.replace(`https://${request_url.split('/')[2]}/signup`);
        // }
        // Old code ---

        // var anchor = `<a href= "https://app.chilll.com/signup" id = "room_id" ><button type="button" class="btn btn-outline-primary btn-lg">Continue with Browser</button></a>`
        // document.getElementById("browser_button").innerHTML = anchor

        // var anchor = `<a href= "https://chilll.page.link/inviteFriend" " ><button type="button" class="btn btn-outline-primary btn-lg">Go to app</button></a>`
        // document.getElementById("app_button").innerHTML = anchor



    }

    function createPasswordView() {

        const queryString = window.location.search; //window.location.href

        const urlParams = new URLSearchParams(queryString)
        const request_url = window.location.href
        const page = urlParams.get('page')
        const tokenId = urlParams.get('tokenId')
        var Name = "Unknown OS";

        if (tokenId) {

            if (navigator.userAgent.indexOf("Win") != -1) {
                Name = "Window OS";
                window.location.replace(`https://${request_url.split('/')[2]}/createPassword/?tokenId=${tokenId}`);
                // window.location.replace(`https://staging-chatapp.chilll.com/${room_id}`);
            }
            // setWebLinkVideo(`https://${request_url.split('/')[2]}/createPassword/?tokenId=${tokenId}`)
            // setAppLinkVideo(res["shortLink"])

            setWebLink(`https://${request_url.split('/')[2]}/createPassword/?tokenId=${tokenId}`)
            // setAppLinkVideo(res["shortLink"])

            // Encode the entire request URL
            const encodedRequestUrl = encodeURIComponent(request_url);

            // Construct app link based on platform
            const appLink = isAndroid
                ? `${baseURI}://deeplink?request_url=${encodedRequestUrl}` // Android app deep link
                : `${baseURI}://deeplink?request_url=${encodedRequestUrl}`; // iOS app deep link

            // Set the app link
            setAppLink(appLink);

        }

    }

    function shareServiceView() {

        const queryString = window.location.search; //window.location.href

        const urlParams = new URLSearchParams(queryString)
        const request_url = window.location.href
        const page = urlParams.get('page')
        const service_id = urlParams.get('serviceRequestId')
        var Name = "Unknown OS";

        if (service_id) {

            if (navigator.userAgent.indexOf("Win") != -1) {
                Name = "Window OS";
                window.location.replace(`https://${request_url.split('/')[2]}/shareableServiceRequest/?serviceRequestId=${service_id}`);
                // window.location.replace(`https://staging-chatapp.chilll.com/${room_id}`);
            }

            // setWebLinkShareService(`https://${request_url.split('/')[2]}/shareableServiceRequest/?serviceRequestId=${service_id}`)
            // setAppLinkShareService(res["shortLink"])

            setWebLink(`https://${request_url.split('/')[2]}/shareableServiceRequest/?serviceRequestId=${service_id}`)
            // Encode the entire request URL
            const encodedRequestUrl = encodeURIComponent(request_url);

            // Construct app link based on platform
            const appLink = isAndroid
                ? `${baseURI}://deeplink?request_url=${encodedRequestUrl}` // Android app deep link
                : `${baseURI}://deeplink?request_url=${encodedRequestUrl}`; // iOS app deep link

            // Set the app link
            setAppLink(appLink);
        }

    }

    function companyiniteView() {

        const queryString = window.location.search; //window.location.href

        const urlParams = new URLSearchParams(queryString)
        const request_url = window.location.href
        const page = urlParams.get('page')
        const company_invitation_token = urlParams.get('companyInvitationToken')
        var Name = "Unknown OS";

        // Deeplink changes for altering firebase dynamic link

        if (company_invitation_token) {

            if (navigator.userAgent.indexOf("Win") != -1) {
                Name = "Window OS";
                window.location.replace(`https://${request_url.split('/')[2]}/companyInvitation/?companyInvitationToken=${company_invitation_token}`);
                // window.location.replace(`https://staging-chatapp.chilll.com/${room_id}`);
            }

            // setWebLinkCompanyInvitation(`https://${request_url.split('/')[2]}/companyInvitation/?companyInvitationToken=${company_invitation_token}`)
            // setAppLinkCompanyInvitation(res["shortLink"])

            setWebLink(`https://${request_url.split('/')[2]}/companyInvitation/?companyInvitationToken=${company_invitation_token}`)

            // Encode the entire request URL
            const encodedRequestUrl = encodeURIComponent(request_url);

            // Construct app link based on platform
            const appLink = isAndroid
                ? `${baseURI}://deeplink?request_url=${encodedRequestUrl}` // Android app deep link
                : `${baseURI}://deeplink?request_url=${encodedRequestUrl}`; // iOS app deep link

            // Set the app link
            setAppLink(appLink);

        }

    }

    function scanView() {

        const queryString = window.location.search; //window.location.href

        const urlParams = new URLSearchParams(queryString);
        const request_url = window.location.href;
        const page = urlParams.get('page');
        const proCode = urlParams.get('pro_code');
        const isFreeSR = urlParams.get('is_free_sr');
        var Name = "Unknown OS";

        // Deeplink changes for altering firebase dynamic link


        if (proCode) {
            localStorage.setItem("proCode", proCode);
            localStorage.setItem("isFreeSR", isFreeSR);

            if (navigator.userAgent.indexOf("Win") != -1) {
                Name = "Window OS";

                if (authorized) {
                    window.location.replace(`https://${request_url.split('/')[2]}/scan`);
                } else {
                    window.location.replace(`https://${request_url.split('/')[2]}/signUpCustomer`);
                }
            }

            if (authorized) {
                setWebLink(`https://${request_url.split('/')[2]}/scan`);
            } else {
                setWebLink(`https://${request_url.split('/')[2]}/signUpCustomer`);
            }

            // Encode the entire request URL
            const encodedRequestUrl = encodeURIComponent(request_url);

            // Construct app link based on platform
            const appLink = isAndroid
                ? `${baseURI}://deeplink?request_url=${encodedRequestUrl}` // Android app deep link
                : `${baseURI}://deeplink?request_url=${encodedRequestUrl}`; // iOS app deep link

            // Set the app link
            setAppLink(appLink);
            // setAppLink(res["shortLink"])
        }


    }


    // When no app install in device opening the playstore or app store
    const openInApp = (e) => {
        // Attempt to open the app link
        e?.preventDefault(); // Prevent default anchor behavior

        setAppLinkLoading(true);

        window.location.href = appLink; // Open the app link


        // Set a timeout to redirect to app stores if the app doesn't open (app not installed)
        const timeout = setTimeout(() => {

            // If app doesn't open, redirect to the Play Store or App Store
            if (isAndroid) {
                window.location.href = "https://play.google.com/store/apps/details?id=com.chilll.app";  // Redirect to Play Store if app not installed
            } else if (isIOS) {
                // window.location.href = "https://apps.apple.com/us/app/chilll/id1621747291";  // Redirect to App Store if app not installed
                // window.location.href = "https://apps.apple.com/us/app/apple-store/id1621747291";
                window.open("https://apps.apple.com/us/app/chilll/id1621747291", "_blank");
            } else {
                window.location.href = "https://play.google.com/store/apps/details?id=com.chilll.app";
            }
        }, 1500);  // 1.5 second timeout to check if app opens

        const id = setTimeout(() => {
            setAppLinkLoading(false);
            // isAndroid && alert('Something went wrong, please try after some time.');
        }, 4000);

        // clearTimeout(timeout); // Clear the timeout if the app is opened
    };

    return (
        <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="deepLink-sub-container" style={{ width: '95%', height: '65%', display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'center', padding: '10px', background: 'white', borderRadius: '20px' }}>
                <div>
                    <div className="d-flex justify-content-center align-items-center" style={{ marginBottom: '15px' }}>
                        <img src={logo} alt="chill app logo" className="logo_login" style={{ marginTop: '60px', width: '150px' }} />
                    </div>
                    {videoVal &&
                        <p style={{ margin: '5px', fontSize: '15px' }}>A service
                            professional is waiting to join you by video to
                            help you with a service request
                        </p>
                    }
                </div>



                {inviteVal &&

                    <div>
                        <p className="deepLink-text" >{`We welcome you to join us.`}</p>

                        <div className="deepLink-btn-group">
                            <a href={webLink} className="deepLink-btn" style={{ margin: '5px' }}>
                                {/* <Button style={{ width: '100%' }}>{`in Browser (no download necessary)`}</Button> */}
                                <Button style={{ width: '100%' }}>
                                    <span>In Web</span>  <br />
                                    <span>(no download necessary)</span>
                                </Button>
                            </a>
                            <a
                                href={appLink}
                                className="deepLink-btn"
                                style={{
                                    margin: '5px',
                                    marginTop: '10px',
                                    pointerEvents: appLinkLoading ? 'none' : 'auto',
                                    opacity: appLinkLoading ? 0.5 : 1
                                }}
                                onClick={(e) => {
                                    // e.preventDefault();
                                    openInApp(e);
                                }}
                            >
                                <Button
                                    style={{
                                        width: '100%',
                                        height: '65px'
                                    }}
                                >
                                    {appLinkLoading ? "Loading..." : "in App"}
                                </Button>
                            </a>
                        </div>

                        <p style={{ margin: '5px', fontSize: '15px' }}>If you don't have the Chilll app, we
                            recomend downloading it for the
                            best experience.
                            {/* <a href={appLinkVideo} style={{ color: 'blue', cursor: 'pointer' }}>Click here</a> */}
                        </p>

                        <a
                            href={appLink}
                            onClick={(e) => {
                                // e.preventDefault();
                                openInApp(e);
                            }}
                            style={{
                                color: 'blue',
                                margin: '0px 5px',
                                fontSize: '15px',
                                pointerEvents: appLinkLoading ? 'none' : 'auto',
                                opacity: appLinkLoading ? 0.5 : 1
                            }}
                        >
                            {"Click here"}
                        </a>

                    </div>

                    // <div>
                    //     <div className="deepLink-btn-group">
                    //         <a href={webLink} style={{ margin: '5px' }}>
                    //             <PrimaryButton buttonName={`In Web (no download necessary)`} />

                    //         </a>
                    //         <a href={appLink} style={{ margin: '5px' }}><PrimaryButton buttonName={"in App"} /></a>
                    //     </div>

                    //     <p style={{ margin: '5px' }}>If you don't have the Chilll app, we
                    //         recomend downloading it for the
                    //         best experience.
                    //     </p>
                    //     <a href={appLink} style={{ color: 'blue', margin: '0px 5px', fontSize: '15px' }}>Click here</a>
                    // </div>

                    // <div>
                    //     <a href={webLink} style={{ margin: '5px' }}><PrimaryButton buttonName={"Continue with browser"} /></a>
                    //     <a href={appLink} style={{ margin: '5px' }}><PrimaryButton buttonName={"Go to app"} /></a>
                    // </div>
                }

                {videoVal &&
                    <div>
                        <p className="deepLink-text" >Open Connection Request...</p>

                        <div className="deepLink-btn-group">
                            <a
                                // href={webLinkVideo} 
                                href={webLink}
                                className="deepLink-btn"
                                style={{ margin: '5px' }}
                            >
                                {/* <Button style={{ width: '100%' }}>{`in Browser (no download necessary)`}</Button> */}
                                <Button style={{ width: '100%' }}>
                                    <span>In Web</span>  <br />
                                    <span>(no download necessary)</span>
                                </Button>
                            </a>
                            <a
                                // href={appLinkVideo} 
                                href={appLink}
                                className="deepLink-btn"
                                style={{
                                    margin: '5px',
                                    marginTop: '10px',
                                    pointerEvents: appLinkLoading ? 'none' : 'auto',
                                    opacity: appLinkLoading ? 0.5 : 1
                                }}
                                onClick={(e) => {
                                    // e.preventDefault();
                                    openInApp(e);
                                }}
                            >
                                <Button style={{ width: '100%', height: '65px' }}>
                                    {appLinkLoading ? "Loading..." : "in App"}
                                </Button>
                            </a>
                        </div>

                        <p style={{ margin: '5px', fontSize: '15px' }}>If you don't have the Chilll app, we
                            recomend downloading it for the
                            best experience.
                            {/* <a href={appLinkVideo} style={{ color: 'blue', cursor: 'pointer' }}>Click here</a> */}
                        </p>

                        <a
                            // href={appLinkVideo}
                            href={appLink}
                            onClick={(e) => {
                                // e.preventDefault();
                                openInApp(e);
                            }}
                            style={{
                                color: 'blue',
                                margin: '0px 5px',
                                fontSize: '15px',
                                pointerEvents: appLinkLoading ? 'none' : 'auto',
                                opacity: appLinkLoading ? 0.5 : 1

                            }}>
                            {"Click here"}
                        </a>
                    </div>
                }

                {createPassVal &&
                    <div>
                        <a
                            // href={webLinkVideo}
                            href={webLink}
                            style={{ margin: '5px' }}>
                            <PrimaryButton buttonName={"Continue with web"} />
                        </a>
                        <a
                            // href={appLinkVideo}
                            href={appLink}

                            style={{
                                margin: '5px',
                                pointerEvents: appLinkLoading ? 'none' : 'auto',
                                opacity: appLinkLoading ? 0.5 : 1
                            }}
                            onClick={(e) => {
                                // e.preventDefault();
                                openInApp(e);
                            }}
                        >
                            <PrimaryButton buttonName={"Go to app"} />
                        </a>
                    </div>
                }

                {shareServiceVal &&
                    <div>
                        <p className="deepLink-text" >Open Service Request Details...</p>

                        <div className="deepLink-btn-group">
                            <a
                                // href={webLinkShareService}
                                href={webLink}
                                className="deepLink-btn"
                                style={{ margin: '5px' }}
                            >
                                {/* <Button style={{ width: '100%' }}>{`in Browser (no download necessary)`}</Button> */}
                                <Button style={{ width: '100%' }}>
                                    <span>In Web</span>  <br />
                                    <span>(no download necessary)</span>
                                </Button>
                            </a>
                            <a
                                //  href={appLinkShareService}
                                href={appLink}
                                className="deepLink-btn"
                                style={{
                                    margin: '5px',
                                    marginTop: '10px',
                                    pointerEvents: appLinkLoading ? 'none' : 'auto',
                                    opacity: appLinkLoading ? 0.5 : 1
                                }}
                                onClick={(e) => {
                                    // e.preventDefault();
                                    openInApp(e);
                                }}
                            >
                                <Button style={{ width: '100%', height: '65px' }}>
                                    {appLinkLoading ? "Loading..." : "in App"}
                                </Button>
                            </a>
                        </div>

                        <p style={{ margin: '5px', fontSize: '15px' }}>If you don't have the Chilll app, we
                            recomend downloading it for the
                            best experience.
                            {/* <a href={appLinkVideo} style={{ color: 'blue', cursor: 'pointer' }}>Click here</a> */}
                        </p>

                        {/* <a href={appLinkShareService} style={{ color: 'blue', margin: '0px 5px', fontSize: '15px' }}>Click here</a> */}
                        <a
                            href={appLink}
                            onClick={(e) => {
                                // e.preventDefault();
                                openInApp(e);
                            }}
                            style={{
                                color: 'blue',
                                margin: '0px 5px',
                                fontSize: '15px',
                                pointerEvents: appLinkLoading ? 'none' : 'auto',
                                opacity: appLinkLoading ? 0.5 : 1
                            }}
                        >
                            {"Click here"}
                        </a>
                    </div>
                }

                {companyInvitationVal &&
                    <div>
                        <div className="deepLink-btn-group">
                            <a
                                // href={webLinkCompanyInvitation}
                                href={webLink}
                                className="deepLink-btn"
                                style={{ margin: '5px' }}
                            >
                                {/* <Button style={{ width: '100%' }}>{`in Browser (no download necessary)`}</Button> */}
                                <Button style={{ width: '100%' }}>
                                    <span>In Web</span>  <br />
                                    <span>(no download necessary)</span>
                                </Button>
                            </a>
                            <a
                                // href={appLinkCompanyInvitation}
                                href={appLink}
                                className="deepLink-btn"
                                style={{
                                    margin: '5px',
                                    marginTop: '10px',
                                    pointerEvents: appLinkLoading ? 'none' : 'auto',
                                    opacity: appLinkLoading ? 0.5 : 1
                                }}
                                onClick={(e) => {
                                    // e.preventDefault();
                                    openInApp(e);
                                }}
                            >

                                <Button style={{ width: '100%', height: '65px' }}>
                                    {appLinkLoading ? "Loading..." : "in App"}
                                </Button>
                            </a>
                        </div>

                        <p style={{ margin: '5px', fontSize: '15px' }}>If you don't have the Chilll app, we
                            recomend downloading it for the
                            best experience.
                            {/* <a href={appLinkVideo} style={{ color: 'blue', cursor: 'pointer' }}>Click here</a> */}
                        </p>

                        {/* <a href={appLinkCompanyInvitation} style={{ color: 'blue', margin: '0px 5px', fontSize: '15px' }}>Click here</a> */}
                        <a
                            href={appLink}
                            onClick={(e) => {
                                // e.preventDefault();
                                openInApp(e);
                            }}
                            style={{
                                color: 'blue',
                                margin: '0px 5px',
                                fontSize: '15px',
                                pointerEvents: appLinkLoading ? 'none' : 'auto',
                                opacity: appLinkLoading ? 0.5 : 1
                            }}
                        >
                            {"Click here"}
                        </a>
                    </div>
                }

                {scanVal &&

                    <div>
                        <p className="deepLink-text" >{`We welcome you to join us.`}</p>

                        <div className="deepLink-btn-group">
                            <a href={webLink} className="deepLink-btn" style={{ margin: '5px' }}>
                                {/* <Button style={{ width: '100%' }}>{`in Browser (no download necessary)`}</Button> */}
                                <Button style={{ width: '100%' }}>
                                    <span>In Web</span>  <br />
                                    <span>(no download necessary)</span>
                                </Button>
                            </a>
                            <a
                                href={appLink}
                                className="deepLink-btn"
                                style={{
                                    margin: '5px',
                                    marginTop: '10px',
                                    pointerEvents: appLinkLoading ? 'none' : 'auto',
                                    opacity: appLinkLoading ? 0.5 : 1
                                }}
                                onClick={(e) => {
                                    // e.preventDefault();
                                    openInApp(e);
                                }}
                            >
                                <Button style={{ width: '100%', height: '65px' }}>
                                    {appLinkLoading ? "Loading..." : "in App"}
                                </Button>
                            </a>
                        </div>

                        <p style={{ margin: '5px', fontSize: '15px' }}>If you don't have the Chilll app, we
                            recomend downloading it for the
                            best experience.
                            {/* <a href={appLinkVideo} style={{ color: 'blue', cursor: 'pointer' }}>Click here</a> */}
                        </p>

                        <a
                            href={appLink}
                            onClick={(e) => {
                                // e.preventDefault();
                                openInApp(e);
                            }}
                            style={{
                                color: 'blue',
                                margin: '0px 5px',
                                fontSize: '15px',
                                pointerEvents: appLinkLoading ? 'none' : 'auto',
                                opacity: appLinkLoading ? 0.5 : 1
                            }}
                        >
                            {"Click here"}
                        </a>

                    </div>


                }

            </div>
        </div>

    );
}
